import ImageCanvasClass, * as ImageCanvasModule from './../../node_modules/ol/source/ImageCanvas.js';

class ImageCanvas extends ImageCanvasClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in ImageCanvasModule) {
    if (key !== "default") {
        ImageCanvas[key] = ImageCanvasModule[key];
    }
}

export default ImageCanvas;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/ImageCanvas.js';